import { t } from 'i18next'
import { validateIBAN as validateIBANTools, electronicFormatIBAN, extractIBAN, ValidationErrorsIBAN } from 'ibantools'

export const SUPPORTED_COUNTRIES = ['DE', 'AT', 'CH', 'LT'] as const
export type SupportedCountry = (typeof SUPPORTED_COUNTRIES)[number]

export const getIBANCountry = (iban: string): string => {
  const extracted = extractIBAN(iban)
  return extracted?.countryCode || iban.substring(0, 2).toUpperCase()
}

export const validateIBAN = (value: string): string | undefined => {
  /* istanbul ignore next */
  if (!value) {
    return t('subscription.sepa.ibanRequired')
  }

  const cleanIBAN = electronicFormatIBAN(value)
  /* istanbul ignore next */
  if (!cleanIBAN) {
    return t('subscription.sepa.ibanInvalid')
  }

  const validation = validateIBANTools(cleanIBAN)

  if (!validation.valid) {
    if (validation.errorCodes.includes(ValidationErrorsIBAN.WrongIBANChecksum)) {
      return t('subscription.sepa.ibanInvalid')
    }
    /* istanbul ignore next */
    if (validation.errorCodes.includes(ValidationErrorsIBAN.WrongBBANLength)) {
      return t('subscription.sepa.ibanInvalid')
    }
    /* istanbul ignore next */
    if (validation.errorCodes.includes(ValidationErrorsIBAN.WrongBBANFormat)) {
      return t('subscription.sepa.ibanInvalid')
    }
    return t('subscription.sepa.ibanInvalid')
  }

  const country = getIBANCountry(cleanIBAN)
  if (!SUPPORTED_COUNTRIES.includes(country as SupportedCountry)) {
    return t('subscription.sepa.ibanCountryNotSupported')
  }

  return undefined
}

export const isBICRequired = (iban: string): boolean => {
  const country = getIBANCountry(iban)
  return country === 'CH'
}
